module.exports = __webpack_public_path__ + "assets/img/logo.307adda3.png";